<template>
  <div
    class="ai-btn"
    v-if="showAiBtn"
    :style="{ marginRight: marginRight + 'px', marginLeft: marginLeft + 'px' }"
  >
    <img @click="showAi" :class="['ai-btn__img', {'small-icon': smallIcon}]" :src="getAiIcon" />
    <ai-tools
      ref="aiTools"
      v-if="showAiService"
      v-model="showAiService"
      :openType="openType"
    />
    <jd-dialog
      title="短信效果设置"
      :visible.sync="deriveDocument"
      width="580px"
      @close="close"
      @comfirm="sureExport"
    >
      <div class="statistics">
        <span>营销后</span>
        <div class="statistics-input">
          <el-input
            v-model="analysisDays"
            placeholder="请输入内容"
            @input="analysisDays = getNumberData(1, $event, 1, 1)"
          >
          </el-input>
        </div>
        <span>天的效果分析结果</span>
      </div>
    </jd-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AiTools from "./aiTools.vue";
export default {
  name: "AiToolsBtn",
  props: {
    openType: {
      type: Number,
      default: 4,
      validator: (v) => [2, 4, 5].includes(v),
    },
    type: {
      type: String,
      default: "hd",
      validator: (v) => ["sence", "hd", "message"].includes(v),
    },
    sendData: {
      type: Array,
      default: () => [],
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    messageTipText: {
      type: String,
      default: "请选择短信活动!",
    },
    otherParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    smallIcon: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AiTools,
  },
  data() {
    return {
      showAiService: false,
      deriveDocument: false,
      analysisDays: null,
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),
    showAiBtn() {
      return (
        this.loginUserInfo &&
        this.loginUserInfo.permissions &&
        this.loginUserInfo.permissions.includes("hide:ai:sms:content")
      );
    },
    getAiIcon() {
      const cdn =
        "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/";
      if (this.openType == 2) {
        return cdn + "ai-icon-yx.svg";
      } else if (this.openType == 4) {
        if (this.smallIcon) {
          return cdn + "ai-icon-fx-new-small.svg";
        } else {
          return cdn + "ai-icon-fx-new.svg";
        }
      } else if (this.openType == 5) {
        return cdn + "ai-icon-qr.svg";
      }
    },
  },
  methods: {
    showAi() {
      if (this.openType == 4) {
        let msg = "";
        if (this.type == "sence") {
          msg = "请选择报表!";
        } else if (this.type == "hd") {
          msg = "请选择互动活动!";
        } else if (this.type == "message") {
          msg = this.messageTipText;
        }
        if (!this.sendData.length) {
          this.$message.warning(msg);
          return;
        }
        if (this.type == "message") {
          if (this.otherParams.analysisDays) {
            this.showAiService = true;
            this.$nextTick(() => {
              this.$refs.aiTools.openByBtn(
                this.sendData,
                this.type,
                this.otherParams
              );
            });
          } else {
            this.deriveDocument = true;
          }
          return;
        }
        this.showAiService = true;
        this.$nextTick(() => {
          this.$refs.aiTools.openByBtn(this.sendData, this.type);
        });
      } else if (this.openType == 2) {
        this.showAiService = true;
        this.$nextTick(() => {
          this.$refs.aiTools.openByBtn(
            "帮我设计一个短信营销活动",
            this.openType
          );
        });
      } else if (this.openType == 5) {
        this.showAiService = true;
        this.$nextTick(() => {
          this.$refs.aiTools.openByBtn("帮我圈选人群", this.openType);
        });
      }
    },
    sureExport() {
      if (!this.analysisDays)
        return this.$message.warning("请输入效果统计时间");
      this.showAiService = true;
      this.$nextTick(() => {
        this.$refs.aiTools.openByBtn(this.sendData, this.type, {
          ...this.otherParams,
          analysisDays: this.analysisDays,
        });
        this.deriveDocument = false;
      });
    },
    close() {
      this.deriveDocument = false;
      this.analysisDays = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-btn {
  display: flex;
  align-items: center;
  &__img {
    cursor: pointer;
    height: 32px;
    width: 88px;
  }
  .small-icon {
    height: 24px;
    width: 66px;
  }
}
.statistics {
  display: flex;
  align-items: center;
  &-input {
    width: 100px;
    margin: 0px 10px;
  }

  /deep/ .el-input__inner {
    width: 100px;
  }
}
</style>
